import React from 'react';
import './Testimonials.css';

const REVIEWS = [
  {
    id: 1,
    clientName: "Sarah & James",
    category: "Wedding",
    rating: 5,
    text: "Shree Photo Studio captured our wedding beautifully! The cinematic quality is unbelievable, and they made us feel so comfortable. Highly recommended."
  },
  {
    id: 2,
    clientName: "Priya Sharma",
    category: "Upanayan",
    rating: 5,
    text: "Absolutely stunning photos. They perfectly captured the spirit and tradition of the ceremony. The team is professional and highly skilled."
  },
  {
    id: 3,
    clientName: "David Collins",
    category: "Product",
    rating: 5,
    text: "Our product catalog has never looked better. The attention to detail, lighting, and composition elevated our entire brand identity."
  },
  {
    id: 4,
    clientName: "Aman Gupta",
    category: "Couple / Maternity",
    rating: 5,
    text: "The photos captured our most precious moments perfectly. Extremely professional and a joy to work with, delivering a stunning premium album."
  },
  {
    id: 5,
    clientName: "Rajesh Kulkarni",
    category: "Industrial",
    rating: 5,
    text: "Shree Photo Studio did an exceptional job capturing our manufacturing facility. The images perfectly highlight our work environment and processes. Truly professional!"
  },
  {
    id: 6,
    clientName: "Vikram Desai",
    category: "Sports",
    rating: 5,
    text: "Amazing action shots that truly captured the energy and passion of the game. Every moment was frozen perfectly. We are absolutely thrilled with the results!"
  }
];

const StarRating = ({ rating }) => {
  return (
    <div className="star-rating">
      {[...Array(5)].map((star, index) => {
        index += 1;
        return (
          <span
            key={index}
            className={index <= rating ? "star filled" : "star"}
          >
            &#9733;
          </span>
        );
      })}
    </div>
  );
};

const Testimonials = () => {
  return (
    <section id="testimonials" className="testimonials-section">
      <div className="container">
        <div className="testimonials-header">
          <div className="section-label">Client Feedback</div>
          <h2 className="section-title">What Our Clients Say</h2>
        </div>

        <div className="testimonials-grid">
          {REVIEWS.map((review) => (
            <div key={review.id} className="testimonial-card">
              <StarRating rating={review.rating} />
              <p className="testimonial-text">"{review.text}"</p>
              <div className="testimonial-author">
                <div className="author-info">
                  <h4>{review.clientName}</h4>
                  <span>{review.category}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;